export function createPlayers() {
   const players = [
    {name: 'Player 1', score: 0, hasTurn: true}, 
    {name: 'Player 2', score: 0, hasTurn: false}
  ];
  
  return players;
}

export function winnerName(players, max) {
  // eslint-disable-next-line
  var players = [...players]; // defensive copy
  const sum = players.reduce((sum, p) => sum + p.score, 0);
  if (sum === max) {
    players.sort((p1, p2) => p2.score - p1.score);
    if (players[0].score === players[1].score) 
      return "a tie";
    else
      return players[0].name;
  }

  return null;
}

export function setPlayerName(players, i, name) {
  // eslint-disable-next-line
  var players = [...players];
  players[i].name = name;
  return players;
}

export function currentPlayerIndex(players) {
  return players.findIndex(player=> player.hasTurn);
}

export function increasePlayerScore(players) {
  // eslint-disable-next-line
  var players = [...players];
  players[currentPlayerIndex(players)].score++;
  return players;
}

export function resetPlayers(players) {
  // eslint-disable-next-line
  var players = [...players]; // discard input, work with copy

  players.forEach(player => {
    player.score = 0;
    player.hasTurn = false;
  });
  players[0].hasTurn = true;

  return players;
}

export function nextPlayerTurn(players) {
  // eslint-disable-next-line
  var players = [...players]; // discard input, work with copy
  const current = players.findIndex(player => player.hasTurn);
  players[current].hasTurn = false;
  players[(current+1) % players.length].hasTurn = true;

  return players;
}

